/**
 * Keeps `iconUrl` in sync with the picked `form.iconFile` as an object-URL
 * preview, revoking the previous URL to avoid blob leaks. Components using this
 * mixin must expose a `form` with an `iconFile` field; they may overwrite
 * `iconUrl` with a server-provided url (e.g. on edit) — revoking a non-blob url
 * is a harmless no-op.
 */
export default {
  data() {
    return {
      iconUrl: null,
    };
  },
  watch: {
    "form.iconFile": function watchIconFile(newFile, oldFile) {
      if (newFile === oldFile) {
        return;
      }

      if (this.iconUrl) {
        URL.revokeObjectURL(this.iconUrl);
      }

      this.iconUrl = newFile ? URL.createObjectURL(newFile) : null;
    },
  },
  beforeDestroy() {
    if (this.iconUrl) {
      URL.revokeObjectURL(this.iconUrl);
    }
  },
};
